/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindAllAgecStatsQueryResponse,
  FindAllAgecStatsQueryParams,
} from "../types/FindAllAgecStats.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findAllAgecStatsQueryKey = (params: FindAllAgecStatsQueryParams) =>
  [
    { url: "/v1/product/find-all-agec-stats" },
    ...(params ? [params] : []),
  ] as const

export type FindAllAgecStatsQueryKey = ReturnType<
  typeof findAllAgecStatsQueryKey
>

/**
 * @summary Find all agec stats
 * {@link /v1/product/find-all-agec-stats}
 */
export async function findAllAgecStats(
  params: FindAllAgecStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAllAgecStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-all-agec-stats`,
    params,
    ...requestConfig,
  })
  return res
}

export function findAllAgecStatsQueryOptions(
  params: FindAllAgecStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findAllAgecStatsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindAllAgecStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAllAgecStatsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findAllAgecStats(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find all agec stats
 * {@link /v1/product/find-all-agec-stats}
 */
export function useFindAllAgecStats<
  TData = ResponseConfig<FindAllAgecStatsQueryResponse>,
  TQueryData = ResponseConfig<FindAllAgecStatsQueryResponse>,
  TQueryKey extends QueryKey = FindAllAgecStatsQueryKey,
>(
  params: FindAllAgecStatsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAllAgecStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findAllAgecStatsQueryKey(params)

  const query = useQuery(
    {
      ...findAllAgecStatsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
